import { makeStyles } from "tss-react/mui"
import { CircularProgress, Grid, Stack } from "@mui/material"

import { LoadingSpinner } from "../../loading/LoadingSpinner"

import { CreateOrderDialogTitle } from "../components/CreateOrderDialogTitle"
import { CreateOrderDialogFlow, CreateOrderFlowType } from "../createOrderTypes"

const useStyles = makeStyles()(() => ({
    content: {
        minHeight: "20rem",
    },
}))
type CreateOrderDialogLoadingProps = Readonly<{
    handleClose: () => void
    flowConfig?: CreateOrderDialogFlow
}>

export function CreateOrderDialogLoading({ handleClose, flowConfig }: CreateOrderDialogLoadingProps) {
    const { classes } = useStyles()
    const isOutlookFlow = flowConfig?.flow === CreateOrderFlowType.OUTLOOK

    return (
        <Stack>
            <CreateOrderDialogTitle handleClose={handleClose} flowConfig={flowConfig} />
            {isOutlookFlow ? (
                // outlook dialog: the spinner stays where the page-load spinner was
                <LoadingSpinner fullPage />
            ) : (
                <Stack>
                    <Grid container alignItems="center" justifyContent="center" className={classes.content}>
                        <CircularProgress size={70} />
                    </Grid>
                </Stack>
            )}
        </Stack>
    )
}
